import React from 'react'
import { useNavigate } from 'react-router-dom'
import ProjectList from '../../../components/restaurantes/ProjectList'
import { useCollection } from '../../../hooks/useCollection'
import { useEffect, useState } from 'react'
import { useAuthContext } from '../../../hooks/useAuthContext'
import AppContext from '../../../context/AppContext'
// styles
import './Dashboard.css'

export default function Dashboard() {
 // const { user, dispatch, szoneNeg } = useAuthContext()
  //const { isPending, error, documents } = useCollection('users', ["email", "==", user.email]) 
  const navigate = useNavigate()

    const userValidate = (e) => {
       // if (documents.length <= 0) {
          //alert("!!! Usuario no registrado para Restaurante !!!")
          //navigate("/")
        //}
    }

    useEffect(() => {
    //  if (documents) {
      //  console.log(user.email, documents)
       // userValidate()
    //  }
      
    },[/*documents*/])
  
  return (
    <div>
        
        <h2 className="page-title">CONFIGURACION</h2>   

        {/*documents && documents.map(usr => (
          AppContext.zoneNeg = usr.zoneNeg,
          AppContext.id = usr.id,
          AppContext.cName = usr.cName,
          AppContext.token = usr.token,
          AppContext.verified = usr.verified,
         <>
            {usr && <ProjectList zoneNeg={usr.zoneNeg} usrID={usr.id} />}
          </>
        ))*/}
    </div>
  )
}
